import { Container } from "@mui/material";
import ProfileHeader from "./ProfileHeader";
import CoreCompetency from "./CoreCompetency";
import { useState } from "react";

export default function Home() {
  const [profileData, setProfileData] = useState({
    name: "PRAMOD MAHAJAN",
    subtitle: "P&L / EBITDA ACCOUNTABILITY | STRATEGY & GROWTH | QUALITY MANAGEMENT",
    description:
      "Strategic, decisive professional leader with proven record in streamlining operations, invigorating businesses, heightening productivity, systems & procedures, targeting assignments as Chief Operating Officer (COO) / Chief Executive Officer (CEO) with an organization of high repute.",
    bullets: [
      "Proven track record of operational excellence",
      "Expertise in business strategy and growth",
      "Strong leadership and quality management skills",
    ],
    photoUrl: "https://media.licdn.com/dms/image/v2/D4D03AQE6-KJKEMNxsQ/profile-displayphoto-scale_200_200/B4DZrjBrDNIgAc-/0/1764745460034?e=2147483647&v=beta&t=mcRt2Riovw_MiuPUakoMngpFydsHgIgqCgE7XiirDqM",
  });



  const [competencies, setCompetencies] = useState([
    { skill: "Leadership", level: 90 },
    { skill: "Strategic Planning", level: 85 },
    { skill: "Operations Management", level: 80 },
    { skill: "Financial Analysis", level: 75 },
    { skill: "Quality Management", level: 80 },
    { skill: "Team Building", level: 90 },
    { skill: "Risk Management", level: 70 },
    { skill: "Process Optimization", level: 85 },
    { skill: "Growth Strategy", level: 88 },
  ]);

  return (
    <Container sx={{ py: 4, backgroundColor: "#FFF" }}>
      <ProfileHeader />
      <CoreCompetency />
    </Container>
  );
}
